export const FEATURES = {
  EGD_React_Overview_Rollout: 'EGD_React_Overview_Rollout',
  EGD_React_End_User_Rollout: 'EGD_React_End_User_Rollout',
  EGD_React_License_Compliance_Rollout: 'EGD_React_License_Compliance_Rollout',
  EGD_React_Language_Selector_Rollout: 'EGD_React_Language_Selector_Rollout',
  EGD_Temporary_Passcode_Rollout: 'EGD_Temporary_Passcode_Rollout',
  EGD_React_Okta_Rollout: 'EGD_React_Okta_Rollout',
  EGD_Email_Banners_Rollout: 'EGD_Email_Banners_Rollout',
  EGD_React_India_Deployment: 'EGD_React_India_Deployment',
  EGD_React_Reporting_Rollout: 'EGD_React_Reporting_Rollout',
  EGD_React_Scheduled_Reports: 'EGD_React_Scheduled_Reports',
  EGD_React_Admin_Threat_Origins: 'EGD_React_Admin_Threat_Origins',
  EGD_Inline_Deployment_Rollout: 'EGD_Inline_Deployment_Rollout',
  EGD_React_Whitelist_Rollout: 'EGD_React_Whitelist_Rollout',
  EGD_React_Block_Sender_Rollout: 'EGD_React_Block_Sender_Rollout',
  EGD_React_Deliver_Rollout: 'EGD_React_Deliver_Rollout',
  EGD_React_Redeliver_Rollout: 'EGD_React_Redeliver_Rollout',
  EGD_React_Inline_Deployment_Rollout: 'EGD_React_Inline_Deployment_Rollout',
  EGD_React_Bulk_Exemptions: 'EGD_React_Bulk_Exemptions',
  EGD_React_QNS_Admin_Quarantine_Notification_Rollout: 'EGD_React_QNS_Admin_Quarantine_Notification_Rollout',
  EGD_React_Converged_Message_Log_Standalone: 'EGD_IP_IR_CML_Standalone_Rollout',
  EGD_React_Smartling_Translations: 'EGD_React_Smartling_Translations',
  EGD_React_Additional_Exemptions: 'EGD_React_Additional_Exemptions'
}
